<template>
  <div class="add-to-cart">
    <div v-if="offer.published && offer.show_buy_button">
      <div v-if="availableQtd > 0" class="cart-actions">
        <div class="price">
          <span class="currency">R$</span>{{ splitPrice(offer.final_price).value }},<span class="decimal">{{ splitPrice(offer.final_price).decimal }}</span>
        </div>
        <div class="qtd">
          <b-form-input v-model="qtd" :max="availableQtd" />
          <div class="buttons">
            <span class="minus" @click="sub()">-</span>
            <span class="plus" @click="add()">+</span>
          </div>
        </div>
        <b-button variant="primary" @click="addToCart(offer)">
          <img src="../assets/img/icon-cart.svg" alt="Adicionar ao carrinho" /> <i class="fa fa-chevron-right"></i>
        </b-button>
        <small class="btn-cart-counter" v-if="alreadyOnCart > 0">{{alreadyOnCart}}</small>
      </div>
      <div class="info">
        <p v-if="offer.product_variation.box_qtd && offer.product_variation.box_qtd.value"><strong>{{offer.product_variation.box_qtd.value}} {{offer.product_variation.box_qtd.unit}}</strong> por caixa/embalagem</p>
        <p v-if="availableQtd == 0">Produto sem estoque</p>
        <p v-else><strong>{{availableQtd}}</strong> disponíveis</p>
      </div>
    </div>
    <div v-else>
      <div class="alert alert-warning">
        Oferta indisponível para compra
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offer: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      qtd: 1
    }
  },
  computed: {
    alreadyOnCart() {
      var qtd = 0
      var cart = this.$store.state.cart
      if (cart && cart.length) {
        qtd = cart.filter(i => i.offer._id == this.offer._id).reduce((a, b) => {
          return a + b.qtd
        }, 0)
      }
      return qtd
    },
    availableQtd() {
      var qtd = 0
      if (this.offer) {
        qtd = this.offer.qtd - this.offer.qtd_ordered - this.alreadyOnCart
      }
      return qtd
    }
  },
  methods: {
    splitPrice(price) {
      const splitedPrice = price.toString().split('.')
      const ret = { value: splitedPrice[0] }
      if (splitedPrice[1]) {
        ret.decimal = splitedPrice[1].slice(0, 2)
      } else {
        ret.decimal = '00'
      }
      if (ret.decimal.length === 1) {
        ret.decimal += '0'
      }
      return ret
    },
    add() {
      if (this.qtd < this.availableQtd) {
        this.qtd += 1
      }
    },
    sub() {
      if (this.qtd > 1) {
        this.qtd -= 1
      }
    },
    addToCart() {
      if (this.qtd <= this.availableQtd) {
        this.$store.dispatch('addToCart', {
          offer: this.offer,
          qtd: this.qtd
        });
        this.notify(this.qtd + ' ' + this.offer.name + ' adicionado ao carrinho')
      } else {
        this.notify('A quantidade solicitada (' + this.qtd + ') excede a quantidade disponível em estoque (' + this.availableQtd + ')', 'error')
      }

    }
  }
}
</script>
<style lang="sass" scoped>
  .add-to-cart
    font-size: 24px
    font-weight: 600
    .cart-actions
      display: inline-block
      margin-bottom: 10px
      .price
        display: inline-block
        margin-right: 5px
        .currency, .decimal
          font-size: 12px
          top: -6px
          position: relative
      .qtd
        width: 70px
        display: inline-block
        margin-right: 5px
        .buttons
          margin: auto
          margin-top: -32px
          font-size: 18px
          font-weight: 200
          .minus
            cursor: pointer
            margin-left: 10px
            width: 20px
          .plus
            float: right
            cursor: pointer
            width: 20px
            display: inline-block
            position: relative
            left: -2px
        input
          border-radius: 15px
          text-align: center
          width: 70px
          color: #215F60
          font-size: 16px
          font-weight: 600
      .btn
        .fa
          font-size: 10px
          margin-left: 5px
      .btn-cart-counter
        display: inline-block
        text-align: center
        font-size: 12px
        font-weight: 400
        background-color: #F58B37
        color: #215F60
        border-radius: 50%
        width: 22px
        height: 22px
        margin-left: -15px
        top: -18px
        position: relative
        padding-top: 3px
    .info
      display: inline-block
      float: right
      p
        text-align: right
        font-size: 12px
        font-weight: 200
        margin: 0
    .alert
      font-size: 14px
</style>
